module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-sm-center"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-8 col-sm-12"
  }, [_c('form', {
    staticClass: "shaded",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.processFormFinish.apply(null, arguments)
      }
    }
  }, [_c('avatar-uploader', {
    attrs: {
      "placeholder": "agent",
      "loadThisImage": _vm.accountSetup.imageLogoBase64
    },
    on: {
      "uploadComplete": _vm.addUploadedAvatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Company name"), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.companyName),
      expression: "form.companyName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Company name"
    },
    domProps: {
      "value": (_vm.form.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "companyName", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.form.companyName.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.form.companyName.required) ? _c('span', [_vm._v("Company name is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.companyName.minLength) ? _c('span', [_vm._v("Your company name must have at least 4 characters.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.getChannelSalesList) ? _c('div', {
    staticClass: "form-group mb-2"
  }, [_vm._m(1), _vm._v(" "), _c('vSelect', {
    attrs: {
      "label": "description",
      "value": _vm.selectedSalesChannel,
      "options": _vm.getChannelSalesList,
      "placeholder": "Pick a sales channel ..."
    },
    on: {
      "input": _vm.updateSalesChannel
    }
  }), _vm._v(" "), (_vm.$v.form.salesChannel.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.form.salesChannel.required) ? _c('span', [_vm._v("Business type is required.")]) : _vm._e()]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Website\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.website),
      expression: "form.website"
    }],
    attrs: {
      "type": "text",
      "placeholder": "www.website.com"
    },
    domProps: {
      "value": (_vm.form.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "website", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.form.website.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.form.website.isWebsiteValid) ? _c('span', [_vm._v("Must be a valid website.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row mt-5 mb-1"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'auth.signup.agent'
      }
    }
  }, [_c('input', {
    staticClass: "btn tertiary widest full",
    attrs: {
      "type": "button",
      "value": "Back"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-center"
  }, [_c('button', {
    staticClass: "btn blue widest full",
    attrs: {
      "type": "submit",
      "value": "Submit",
      "disabled": _vm.$v.$invalid || _vm.submittingRegistration
    }
  }, [(_vm.submittingRegistration) ? _c('loader') : _c('span', [_vm._v("Submit")])], 1)])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signup-header row border-bottom-light row justify-content-sm-center"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h5', {
    staticClass: "color-1"
  }, [_vm._v("Your business")]), _vm._v(" "), _c('h2', [_vm._v("Can you tell me a little bit about your business?")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "full"
  }, [_vm._v("Business Type"), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2963fdeb"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/agent/Step2.vue
// module id = 2305
// module chunks = 0